import { EditableField } from '../../../../commonComponents/EditableField';
import { FormField } from '../../shared/FormField';
import { formatDate } from '../../shared/utils';

export const EducationField = ({ educations = [], educationsForm = [], isEditing, onChange }) => {
  const isCurrentEducation = (index) => index === 0 && educationsForm?.[index]?.currentlyEnrolled;

  return (
    <EditableField
      editing={isEditing}
      view={
        educations?.length
          ? educations.map((education, index) => (
              // eslint-disable-next-line react/no-array-index-key
            <div key={`education-${index}`} className="mt-5">
              <span className="f-16 bold">School Attended</span>
              <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '24px',
                    gap: '20px',
                  }}
                >
                <span className="f-16">{education.institutionName}</span>
                <span className="f-16">
                  Graduation Date:{' '}
                  {education.currentlyEnrolled ? (
                    <span>
                      Present <span style={{ fontStyle: 'italic' }}>(current)</span>
                    </span>
                    ) : (
                      formatDate(education.endDate, 'M/D/YYYY')
                    )}
                </span>
              </div>
            </div>
            ))
          : '-'
      }
      // always populate 1 education in edit mode
      edit={Array.from({ length: 1 }, (_, index) => (
        <div key={`education-${index}`} style={{ marginTop: '18px' }}>
          <div style={{ display: 'flex', gap: '20px' }}>
            <FormField label="School Attended" style={{ width: '500px' }}>
              <input
                className="form-control"
                type="text"
                value={educationsForm?.[index]?.institutionName || ''}
                onChange={(e) => onChange(index, 'institutionName', e.target.value)}
              />
            </FormField>
            <FormField label="End Date" style={{ width: '150px' }}>
              <input
                className="form-control"
                type={isCurrentEducation(index) ? 'text' : 'date'}
                value={
                  isCurrentEducation(index)
                    ? 'Present'
                    : formatDate(educationsForm?.[index]?.endDate)
                }
                disabled={isCurrentEducation(index)}
                onChange={(e) => onChange(index, 'endDate', e.target.value)}
              />
            </FormField>
          </div>
          {index === 0 && (
            <div
              onClick={() =>
                onChange(index, 'currentlyEnrolled', !educationsForm?.[index]?.currentlyEnrolled)
              }
              style={{
                display: 'flex',
                width: 'fit-content',
                alignItems: 'center',
                marginTop: 8,
                cursor: 'pointer',
                gap: 8,
              }}
            >
              <input
                type="checkbox"
                checked={educationsForm?.[index]?.currentlyEnrolled || false}
                readOnly
                style={{ pointerEvents: 'none', margin: 0 }}
              />
              <p className="f-15" style={{ marginBottom: 0 }}>
                Currently Enrolled
              </p>
            </div>
          )}
        </div>
      ))}
    />
  );
};
